module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web25.b111b9d0.jpg";